import { useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { useLazyGetPaymentDetailsQuery } from '../../services/accountPayableApi';
export function useGetPaymentDetails() {
    const { t } = useTranslation();
    const [trigger] = useLazyGetPaymentDetailsQuery();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [paymentDetails, setPaymentDetails] = useState();
    async function getPaymentDetails(id, rethrow) {
        setLoading(true);
        setError(undefined);
        setPaymentDetails(undefined);
        try {
            const { data } = await trigger({ id }, false);
            if (!data?.result) {
                throw new Error(t('can-not-find-the-bank-details'));
            }
            else {
                setPaymentDetails(data.result);
                return data.result;
            }
        }
        catch (error) {
            setError(t('can-not-find-the-bank-details'));
            if (rethrow) {
                throw error;
            }
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        paymentDetails,
        setPaymentDetails,
        getPaymentDetails,
    };
}
